import { Typography, makeStyles } from '@material-ui/core';
import React, { Fragment } from 'react';
import clsx from 'clsx';

interface IDescriptionsProps {
  description1: string;
  description2: string;
}

const useStyles = makeStyles((theme) => ({
  textPrimary: {
    color: theme.palette.text.primary,
  },
}));


const Descriptions = ({ description1, description2 }: IDescriptionsProps) => {
  const classes = useStyles();

  return (
    <Fragment>
      <Typography variant='body1' color='textPrimary' className={clsx(classes.textPrimary,'pb-5 whitespace-pre-line font-body text-justify')}>
        { description1 }
      </Typography>
      <Typography variant='body1' color='textPrimary' className={clsx(classes.textPrimary,'whitespace-pre-line font-body text-justify')}>
        { description2 }
      </Typography>
    </Fragment>
  );
};
export default Descriptions;
